export enum WipPermissionEnum {
    None        = 0x00,
    CanView     = 0x01 << 0,
    CanEdit     = 0x01 << 1,
}
